// package: trendhim.service.customers
// file: protos/customers/customers.proto

var protos_customers_customers_pb = require("../../protos/customers/customers_pb");
var grpc = require("@improbable-eng/grpc-web").grpc;

var Customers = (function () {
  function Customers() {}
  Customers.serviceName = "trendhim.service.customers.Customers";
  return Customers;
}());

Customers.GetCustomerID = {
  methodName: "GetCustomerID",
  service: Customers,
  requestStream: false,
  responseStream: false,
  requestType: protos_customers_customers_pb.GetCustomerIDRequest,
  responseType: protos_customers_customers_pb.GetCustomerIDResponse
};

Customers.GetCustomer = {
  methodName: "GetCustomer",
  service: Customers,
  requestStream: false,
  responseStream: false,
  requestType: protos_customers_customers_pb.GetCustomerRequest,
  responseType: protos_customers_customers_pb.GetCustomerResponse
};

Customers.UpdateCustomer = {
  methodName: "UpdateCustomer",
  service: Customers,
  requestStream: false,
  responseStream: false,
  requestType: protos_customers_customers_pb.UpdateCustomerRequest,
  responseType: protos_customers_customers_pb.UpdateCustomerResponse
};

exports.Customers = Customers;

function CustomersClient(serviceHost, options) {
  this.serviceHost = serviceHost;
  this.options = options || {};
}

CustomersClient.prototype.getCustomerID = function getCustomerID(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Customers.GetCustomerID, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

CustomersClient.prototype.getCustomer = function getCustomer(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Customers.GetCustomer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

CustomersClient.prototype.updateCustomer = function updateCustomer(requestMessage, metadata, callback) {
  var cancelled = false;
  var shouldReturnPromise = true;
  if (arguments.length === 2 && typeof arguments[1] === 'function') {
    shouldReturnPromise = false;
    callback = arguments[1];
  } else if (arguments.length === 3) {
    shouldReturnPromise = false;
  }
  var acceptPromise;
  var rejectPromise;
  var promise = new Promise(function (accept, reject) {
    acceptPromise = accept;
    rejectPromise = reject;
  });
  var client = grpc.unary(Customers.UpdateCustomer, {
    request: requestMessage,
    host: this.serviceHost,
    metadata: metadata,
    transport: this.options.transport,
    debug: this.options.debug,
    onEnd: function (response) {
      if (cancelled) {
        return;
      }
      if (response.status !== grpc.Code.OK) {
        var err = new Error(response.statusMessage);
        err.code = response.status;
        err.metadata = response.trailers;
        callback && callback(err, null);
        rejectPromise(err);
        return;
      }
      callback && callback(null, response.message);
      acceptPromise(response.message);
    }
  });
  if (shouldReturnPromise) {
    return promise;
  }
  return {
    cancel: function () {
      callback = null;
      cancelled = true;
      client.close();
    }
  };
};

exports.CustomersClient = CustomersClient;

